/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Create_Name_MinInputs */



/**
* | output |
* | --- |
* | "Space name must be at least 3 characters" |
*
* @param {Spaces_Create_Name_MinInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_create_name_min = /** @type {((inputs?: Spaces_Create_Name_MinInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Create_Name_MinInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Spacename muss mindestens 3 Zeichen lang sein")
	return /** @type {LocalizedString} */ ("Space name must be at least 3 characters")
});